import { useApi } from 'services';

export const useGetDocuments = (idOperation) => useApi(`v2/operation/${idOperation}/documents`, 'GET', {}, {})

export const useUpdateDocument = (idOperation, idDocument) => useApi(`v2/operation/${idOperation}/documents/${idDocument}`, 'PUT', {}, {})

export const useGetDealDocumentsV2 = (idOperation) => useApi(`/quote/v2/list-documents/${idOperation}`, 'GET', {}, {}, true)

export const useGetDealDocuments = (idOperation) => useApi(`/quote/list-documents/${idOperation}`, 'GET', {}, {}, true)

export const useDownloadAllFiles = () => useApi(`/document/download/all-files`, 'POST', {}, {}, true);

export const useDeleteSchedulleAssumptions = () => useApi(`/quote/attachments/v3`, 'DELETE', {}, {}, true);

export const useGetOperationDocuments = (idOperation) => useApi(`operation/v2/${idOperation}/operation-documents`, 'GET', {},)